export default "__VITE_ASSET__DsXNv0H___"